exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2mf-TJt4s7KS3bHDKIaz_5 ._1ThAypeWaP4T12RssTnmKJ{display:flex;justify-content:space-around;padding-bottom:30px;margin-left:30px;margin-right:30px}._2mf-TJt4s7KS3bHDKIaz_5 ._1ThAypeWaP4T12RssTnmKJ ._1dA38mvwl98SVzng8k7_A6{flex:0 0 auto;font-size:40px;color:#fff}._2mf-TJt4s7KS3bHDKIaz_5 ._1ThAypeWaP4T12RssTnmKJ ._1dA38mvwl98SVzng8k7_A6:visited,._2mf-TJt4s7KS3bHDKIaz_5 ._1ThAypeWaP4T12RssTnmKJ ._1dA38mvwl98SVzng8k7_A6:active,._2mf-TJt4s7KS3bHDKIaz_5 ._1ThAypeWaP4T12RssTnmKJ ._1dA38mvwl98SVzng8k7_A6:hover{text-decoration:none}._2mf-TJt4s7KS3bHDKIaz_5 ._2gi0l9oHhY9wJyzaXMrGaG{margin-top:-2px;margin-right:5px}\n", ""]);

// Exports
exports.locals = {
	"ShareDialog": "_2mf-TJt4s7KS3bHDKIaz_5",
	"shareIcons": "_1ThAypeWaP4T12RssTnmKJ",
	"icon": "_1dA38mvwl98SVzng8k7_A6",
	"ctaIcon": "_2gi0l9oHhY9wJyzaXMrGaG"
};